<template>
  <div class="ended-popup-component">
    <ym-popup class="ended-popup-content"
              v-model="visible"
              get-container="body"
    >
      <div class="ended-popup-hint">
        <h2 class="ended-popup-hint-title">活动已结束</h2>
        可长按扫码了解「<span class="strong">少年商学院</span>」<br/>
        更多课程信息
      </div>
      <div class="ended-popup-image">
        <img :src="require('@/assets/img/default/web_home_index.png')" alt="H5首页" />
      </div>
    </ym-popup>
  </div>
</template>

<script>
  import { Popup } from '@ymba/ym-ui';

  export default {
    name: 'EndedPopup',
    components: {
      'ym-popup': Popup,
    },
    props: {
      show: {
        type: Boolean,
        required: true,
      },
    },
    data() {
      return {
        visible: false,
      };
    },
    watch: {
      show(val) {
        this.visible = val;
      },
      visible(val) {
        this.$emit('update:show', val);
      },
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .ended-popup {
    &-content {
      box-sizing: border-box;
      width: 520px;
      padding: 40px 30px 60px;
      font-size: 28px;
      line-height: 1.6;
      text-align: center;
      border-radius: 12px;
    }

    &-hint {

      &-title {
        margin: 0 auto 10px;
        font-size: 32px;
      }

      .strong {
        font-weight: 500;
      }

      &::after {
        content: '';
        display: block;
        width: 0;
        height: 0;
        margin: 10px auto 0;
        border-width: 20px;
        border-style: solid;
        border-color: #f3cc7c transparent transparent transparent;
      }
    }

    @qr-code-size: 240px;
    &-image {
      width: @qr-code-size;
      height: @qr-code-size;
      margin: 0 auto;
      overflow: hidden;
      border: 1px solid #dfc594;
      border-radius: 12px;

      img {
        display: block;
        width: 100%;
        height: 100%;
        border-radius: inherit;
      }
    }
  }
</style>
